import { lazy, Suspense, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { X } from "lucide-react";
import { pageKey } from "@/lib/chat";

const ChatPanel = lazy(() => import("@/components/chat/ChatPanel"));
const TEASED = "rl_chat_teased";
const HOOKS = {
  home: "Stai cercando qualcuno da mesi e arrivano solo CV a caso?",
  landing: "Quale figura ti serve? In 30 secondi ti dico come la troveremmo.",
};

const blocked = () => {
  if (document.querySelector("[data-testid='cookie-banner']")) return true;
  const f = document.getElementById("richiedi");
  if (!f) return false;
  const r = f.getBoundingClientRect();
  return r.top < window.innerHeight && r.bottom > 0;
};

const FlaskIcon = () => (
  <svg width="26" height="26" viewBox="0 0 40 40" fill="none" aria-hidden="true">
    <rect x="14.5" y="4" width="11" height="7" rx="2.4" stroke="#fff" strokeWidth="2.4" />
    <path d="M16 11v3.2L8.6 31.4c-.5 1.2.2 2.4 1.5 2.6 6.6 1.2 13.2 1.2 19.8 0 1.3-.2 2-1.4 1.5-2.6L24 14.2V11" stroke="#fff" strokeWidth="2.4" strokeLinejoin="round" />
    <circle cx="20" cy="20.4" r="3.4" fill="#EF9F27" />
  </svg>
);

export const ChatLauncher = () => {
  const { pathname } = useLocation();
  const key = pageKey(pathname);
  const [open, setOpen] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [teaser, setTeaser] = useState(false);
  const btnRef = useRef(null);

  useEffect(() => {
    if (sessionStorage.getItem(TEASED)) return;
    let t;
    const tryShow = () => {
      if (open || sessionStorage.getItem(TEASED)) return;
      if (blocked()) { t = setTimeout(tryShow, 3000); return; }
      setTeaser(true);
      sessionStorage.setItem(TEASED, "1");
    };
    t = setTimeout(tryShow, 18000);
    return () => clearTimeout(t);
  }, [pathname, open]);

  if (pathname.startsWith("/admin")) return null;
  const openChat = () => { setTeaser(false); setLoaded(true); setOpen(true); };
  const close = () => { setOpen(false); setTimeout(() => btnRef.current && btnRef.current.focus(), 50); };

  return (
    <>
      {teaser && !open && (
        <div className="fixed bottom-[164px] right-4 z-[55] max-w-[260px] lg:bottom-[96px] lg:right-6" style={{ animation: "rl-step-in .5s cubic-bezier(.16,1,.3,1) both" }} data-testid="chat-teaser">
          <div className="relative rounded-2xl border border-[#E7E5DF] bg-white p-4 pr-9 text-[14px] leading-snug text-[#2C2C2A] shadow-[0_20px_50px_-20px_rgba(19,53,47,0.45)]">
            <button type="button" onClick={openChat} className="text-left" data-testid="chat-teaser-open">{HOOKS[key] || "Hai un ruolo da coprire? Chiedimi come lavoriamo."}</button>
            <button type="button" onClick={() => setTeaser(false)} aria-label="Chiudi suggerimento" className="absolute right-2 top-2 rounded-full p-1 text-[#6B6961] hover:bg-[#F7F6F2]" data-testid="chat-teaser-close"><X size={14} /></button>
          </div>
        </div>
      )}
      {!open && (
        <button
          ref={btnRef}
          type="button"
          onClick={openChat}
          aria-label="Apri la chat con l'Assistente Recruiting Lab"
          className="fixed bottom-[96px] right-4 z-[55] inline-flex h-14 w-14 items-center justify-center rounded-full bg-[#0F6E56] shadow-[0_16px_40px_-14px_rgba(15,110,86,0.8)] transition-transform duration-300 hover:scale-105 active:scale-95 lg:bottom-6 lg:right-6"
          data-testid="chat-launcher"
        >
          <FlaskIcon />
          <span className="absolute right-1 top-1 h-3 w-3 rounded-full border-2 border-white bg-[#EF9F27] rl-pulse" aria-hidden="true" />
        </button>
      )}
      {loaded && (
        <Suspense fallback={null}>
          <ChatPanel open={open} onClose={close} pageKey={key} />
        </Suspense>
      )}
    </>
  );
};
